import { Suspense, type FC } from 'react';
import { Route } from 'react-router';
import { useNotificationService } from 'src/apis/notification-service/use-notification-service-root';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { PageSpinner } from 'src/components/spinner-container';
import { NotificationDetails } from 'src/pages/your-timeline-notifications/details';
import { NotificationsOverview } from 'src/pages/your-timeline-notifications/overview';

export const NotificationsRoot: FC = () => {
  const notificationService = useNotificationService();

  if (!notificationService.response) {
    return <PageSpinner />;
  }

  return (
    <Suspense fallback={<PageSpinner />}>
      <RootRoutes>
        <Route
          path="/notifications"
          element={
            <NotificationsOverview notificationService={notificationService} />
          }
        />

        <Route
          path="/notifications/:notificationId"
          element={
            <NotificationDetails notificationService={notificationService} />
          }
        />

        <Route path="*" element={<ThrowNotFound />} />
      </RootRoutes>
    </Suspense>
  );
};
